// src/components/ProtectedRoute.js

import React from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../apiServices/authService';

const ProtectedRoute = ({ children, allowedUserTypes = [] }) => {
    // const isAuthenticated = authService.isAuthenticated();
    const userType = authService.getUserType();

    // Check if user is authenticated
    // if (!isAuthenticated) {
    //     return <Navigate to="/login" replace />;
    // }
        if (!userType) {
        return <Navigate to="/login" replace />;
    }

    // Check if user type is allowed
    if (allowedUserTypes.length > 0 && !allowedUserTypes.includes(userType)) {
        // Redirect to appropriate dashboard based on user type
        const dashboardUrl = authService.getDashboardUrl();
        return <Navigate to={dashboardUrl} replace />;
    }

    return children;
};

export default ProtectedRoute;